import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { EASE_OUT } from '../utils/motion';
type ThemeToggleProps = {
  className?: string;
};
export function ThemeToggle({
  className = ''
}: ThemeToggleProps) {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDark = theme === 'dark';
  return <button type="button" onClick={toggleTheme} aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} aria-pressed={isDark} className={`relative grid h-9 w-9 shrink-0 place-items-center overflow-hidden rounded-full border border-line text-fg-muted transition-[color,border-color,transform] duration-150 ease-out hover:border-fg/30 hover:text-fg active:scale-[0.94] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/40 ${className}`} data-id="element-674" data-mp="2pf03f5h2z90s">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-675" data-mp="im7g6w4bl8q1">
        <motion.span key={isDark ? 'moon' : 'sun'} initial={{
        opacity: 0,
        rotate: -90,
        scale: 0.6
      }} animate={{
        opacity: 1,
        rotate: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        rotate: 90,
        scale: 0.6
      }} transition={{
        duration: 0.2,
        ease: EASE_OUT
      }} className="absolute" data-id="element-676" data-mp="1ganee1486g6o">
          {isDark ? <MoonIcon className="h-4 w-4" data-id="element-677" data-mp="12acob0aqp5mk" /> : <SunIcon className="h-4 w-4" data-id="element-678" data-mp="12did0efgi5hr" />}
        </motion.span>
      </AnimatePresence>
    </button>;
}